/* Zumpo/Name menu: a 320 px paper card, lifted, under what opened it. */
.menu {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-16);
  box-sizing: border-box;
  width: 320px;
  padding: var(--zumpo-space-32);
  border-radius: var(--zumpo-radius-24);
  background: var(--zumpo-paper);
  /* Inset, as Figma's stroke takes no room: Save and Roll a name share a row. */
  box-shadow:
    inset 0 0 0 1px var(--zumpo-line),
    var(--zumpo-shadow-menu-lift);
  outline: none;
  transition:
    opacity 150ms ease-out,
    transform 150ms ease-out;
}

.menu[data-starting-style],
.menu[data-ending-style] {
  opacity: 0;
  transform: translateY(-4px);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-16);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--zumpo-space-12);
}

@media (prefers-reduced-motion: reduce) {
  .menu {
    transition: none;
  }
}

/* MO02: the width of the screen less its 16 px margins. */
@media (max-width: 640px) {
  .menu {
    width: calc(100vw - 2 * var(--zumpo-space-16));
  }
}
